<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៣.ក(១, ២)
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៣.ខ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៣.គ(១, ២, ៣)
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <classenv :data="claenv" :title="title[1]" />            
            <classpre :data="mpre" :title="title[2]" />
            <classpri :data="mpri" :title="title[2]" />
            <classsec :data="msec" :title="title[2]" />            
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <preintoy :data="mtoy" :title="title[3]" />                        
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <preprog :prog="ppre" :title="title[4]" />
            <privprog :prog="ppri" :title="title[5]" :level="priLevel" />
            <privprog :prog="psec" :title="title[6]" :level="secLevel" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>


<script>

import classEnv from "@/components/privateascf/sec/classEnv26.vue";
import classPre from "@/components/privateascf/pre/classPre.vue";
import classPri from "@/components/privateascf/pri/classPri.vue";
import classSec from "@/components/privateascf/sec/classSec.vue";

import preProgram from "@/components/privateascf/pre/preprogram.vue";
import privProgram from "@/components/privateascf/sharedCom/privateProgram.vue";
import preInternalToy from "@/components/ascf/pre/preInternalToy.vue";

import { secLevel } from "@/utils/priascf/secVariables.js";
import { priLevel } from "@/utils/priascf/priVariables.js";

export default {
  props: ["title", "claenv", "mpre", "mpri", "msec", "mtoy", "ppre", "ppri", "psec"],
  components: {
    classenv: classEnv,
    classpre: classPre,
    classpri: classPri,
    classsec: classSec,
    preintoy: preInternalToy,
    preprog: preProgram,
    privprog: privProgram
  },
  data() {
    return {
      active_tab: 0,
      priLevel: priLevel,
      secLevel: secLevel,
    };
  },
};
</script>
<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>